import { AuthBloc } from './../../bloc/auth.bloc';
import { RouteHelper } from './../../helpers/route.helpers';
import { ProfileDataDTO } from './../../dto/account/profile.dto';
import { dataEnum } from './../../helpers/data.enum';
import { AuthMemberPayloadDto } from './../../dto/auth/auth.dto';
import { EncryptDataService } from './../../helpers/encrypt.service';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  constructor(
    public routeHelper: RouteHelper,
    private encryptDataService: EncryptDataService,
    private authBloc: AuthBloc
  ) {}

  loginMemberFg = new FormGroup({
    email: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    recaptcha: new FormControl('', Validators.required)
  });

  isCustomer: boolean;

  errResponse: string;
  preloader: boolean;
  dataLogin: AuthMemberPayloadDto;

  fieldTextType: boolean;
  siteKey :string
  size :any
  themecaptcha :any
  type :any

  ngOnInit() {
    this.size = "normal";
    this.themecaptcha = "light";
    this.type = "image";
    this.siteKey = "6LcNTUcgAAAAAMP7brHhKd9zx72oV4iNYJ98flGD";
    // remove user from local storage and set current user to null
    localStorage.removeItem(dataEnum.auth);
    localStorage.removeItem(dataEnum.profile);
    localStorage.removeItem(dataEnum.ekyc);
    localStorage.removeItem(dataEnum.menu);

    this.preloader = false;
    window.scrollTo(0, 0);

  }

  closeAlert() {
    this.errResponse = null;
  }
  get validate() {
    return this.loginMemberFg.controls;
  }

  async onSubmitMember() {
    const payload: AuthMemberPayloadDto = this.loginMemberFg.value;
    if (this.loginMemberFg.valid) {
      this.preloader = true;
      const response = await this.authBloc.authentication(payload);
      if (response.data) {
        const hashPrelogin = JSON.stringify(response.data);
        const encryptPrelogin =
          this.encryptDataService.encryptData(hashPrelogin);

        localStorage.setItem(dataEnum.auth, encryptPrelogin);

        const resultProfileData = await this.authBloc.getAccountInfo();
        if (!resultProfileData) {
          Swal.fire(
            'Ops!',
            'Ops! Something when wrong to get profile data',
            'error'
          );
          this.preloader = false;
          return;
        }

        const resultEkyc = await this.authBloc.getEkyc();
        if (!resultEkyc) {
          Swal.fire(
            'Ops!',
            'Ops! Something when wrong to get EKYC data',
            'error'
          );
          this.preloader = false;
          return;
        }

        resultProfileData.userType = dataEnum.customer;

        // set ekyc data
        localStorage.setItem(
          dataEnum.ekyc,
          this.encryptDataService.encryptData(
            JSON.stringify(resultEkyc.data.statusEkyc)
          )
        );

        // set profile data
        await this.setLocalStorage(null, resultProfileData);

        // if profile not verified
        if (Number(resultEkyc.data.statusEkyc) !== 1) {
          this.routeHelper.navigated('/member/profile');
        } else {
          this.routeHelper.navigated('/member');
        }
      } else {
        Swal.fire('Ops!', response.message, 'error');
        this.preloader = false;
        return;
      }
      this.preloader = false;
    }else{
      if(payload.recaptcha === ''){
        Swal.fire(
          'Ops!',
          'Ops! Captcha Invalid',
          'error'
        );
        this.preloader = false;
        return;
      }else{
        Swal.fire(
          'Ops!',
          'Ops! Username / Password Wrong!',
          'error'
        );
        this.preloader = false;
        return;
      }
    }
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  async setLocalStorage(
    resultMenuData: any,
    resultProfileData: ProfileDataDTO
  ) {
    if (resultMenuData) {
      const hashMenuData = JSON.stringify(resultMenuData);
      localStorage.setItem(
        dataEnum.menu,
        this.encryptDataService.encryptData(hashMenuData)
      );
    }

    if (resultProfileData) {
      const hashProfile = JSON.stringify(resultProfileData);
      localStorage.setItem(
        dataEnum.profile,
        this.encryptDataService.encryptData(hashProfile)
      );
    }
  }

  simpleAlert() {
    // Swal.fire('Hello world!');
    Swal.fire('Thank you...', 'You submitted succesfully!', 'error');
  }

  confirmBox() {
    Swal.fire({
      title: 'Are you sure want to remove?',
      text: 'You will not be able to recover this file!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }
}
